'use client';
/** @jsxImportSource @emotion/react */

import type { AlertTitleProps as MuiAlertTitleProps } from '@mui/material/AlertTitle';

import MuiAlertTitle from '@mui/material/AlertTitle';

type AlertTitleProps = MuiAlertTitleProps;
export type { AlertTitleProps };
export const AlertTitle: React.FC<AlertTitleProps> = MuiAlertTitle;

AlertTitle.displayName = 'AlertTitle';
